import React, { useState } from "react";
import styles from "../MyPageEditModal.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormInput from "../../../../common/forms/FormInput";
import {
  SonicGameSelectionData,
  SonicGameSelectionItem,
} from "../../../../common/classes/SonicGameSelection";
import {
  SonicGameDetail,
  SonicGameDetailData,
} from "../../../../common/classes/SonicGameDetail";
import LoadingSpinner from "../../../../common/LoadingSpinner";

type Props = {
  isLoading: boolean;
  gameId: string;
  gameTitle?: string;
  gameSelection?: SonicGameSelectionData;
  initialValue?: SonicGameDetailData;
  handleUpdate: (update: SonicGameDetailData) => void;
  handleClose: () => void;
};
const EditGameDetailModal: React.FC<Props> = ({
  isLoading,
  gameId,
  gameTitle,
  gameSelection,
  initialValue,
  handleUpdate,
  handleClose,
}) => {
  const [detail, setDetail] = useState<SonicGameDetailData>(
    initialValue ? initialValue : SonicGameDetail.genInitialData(gameId)
  );

  const genOptions = (
    items?: Array<SonicGameSelectionItem>,
    deletedCheck?: string
  ) => {
    const options: Array<[string, string]> = [["", "未選択"]];

    if (items) {
      for (const item of items) {
        options.push([item.id, item.value]);
      }
    }

    if (items && deletedCheck) {
      const check = items.filter((i) => i.id === deletedCheck);

      if (!check.length) {
        options.push([deletedCheck, "選択項目が削除されました"]);
      }
    }

    return options;
  };
  return (
    <div className={styles["mypage-editModal-wrapper"]}>
      <div className={styles["mypage-editModal"]}>
        <i className={styles["mypage-editModal__close"]} onClick={handleClose}>
          <FontAwesomeIcon icon={["fas", "times"]} />
        </i>

        {isLoading ? (
          <LoadingSpinner space={1} />
        ) : (
          <>
            <div className={styles["mypage-editModal__form"]}>
              <span className={styles["mypage-editModal__form-title"]}>
                ゲーム名
              </span>
              <div className={styles["mypage-editModal__form-preview"]}>
                {gameTitle}
              </div>
            </div>
            <div className={styles["mypage-editModal__form"]}>
              <FormInput
                type="select"
                label="ランク"
                label_class={styles["mypage-editModal__form-title"]}
                name="sonic_game_rank"
                select_class={`${styles["mypage-editModal__form-input"]} ${styles["select"]}`}
                holder_class={`${styles["mypage-editModal__form-input"]} ${styles["holder"]}`}
                handler={(value: string | File | undefined) => {
                  if (typeof value === "string")
                    setDetail({ ...detail, rank: value });
                }}
                initial_value={detail?.rank ? detail.rank : undefined}
                options={genOptions(gameSelection?.rank, detail?.rank)}
              />
            </div>
            <div className={styles["mypage-editModal__btn-area"]}>
              <button
                className={`${styles["mypage-editModal__btn-area__btn"]} ${styles["cancel"]}`}
                type="button"
                onClick={handleClose}
              >
                キャンセル
              </button>
              <button
                className={`${styles["mypage-editModal__btn-area__btn"]} ${styles["confirm"]}`}
                type="button"
                onClick={() => handleUpdate(detail)}
              >
                OK
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EditGameDetailModal;
